// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar.drag-bar {
  -webkit-app-region: drag;
}

ion-menu ion-content {
  --padding-top: 44px;
  --background: rgba(var(--ion-color-light-rgb), 0.5);
}

ion-split-pane {
  --side-max-width: 50%;
  --side-width: 250px;
  --side-min-width: 90px;
}
ion-split-pane ion-menu {
  --width: 100%;
  transition: border 0.25s;
}
ion-split-pane ion-menu ion-list,
ion-split-pane ion-menu ion-item,
ion-split-pane ion-menu ion-list-header {
  --background: rgba(var(--ion-color-light-rgb), 0.5);
}

ion-menu.md ion-content {
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 0 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu ion-list#top-list ion-item.title {
  --min-height: 95px;
}
ion-menu ion-list#top-list ion-item.title ion-label {
  font-size: 22px;
  font-weight: 600;
}

ion-menu.md ion-list#top-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

ion-menu.md ion-list#top-list ion-list-header {
  font-size: 22px;
  font-weight: 600;
  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: #757575;
  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.md ion-item ion-icon {
  color: #616e7e;
}

ion-menu.md ion-item ion-label {
  font-weight: 500;
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}

ion-menu.ios ion-list ion-list-header {
  padding-bottom: 8px;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-note {
  display: inline-block;
  font-size: 16px;
  color: var(--ion-color-medium-shade);
}

ion-item.selected {
  --color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,mBAAA;EACA,mDAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,sBAAA;AACF;AAAE;EACE,aAAA;EACA,wBAAA;AAEJ;AADI;;;EAGE,mDAAA;AAGN;;AAEA;EACE,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,kBAAA;AACF;;AAGE;EACE,kBAAA;AAAJ;AACI;EACE,eAAA;EACA,gBAAA;AACN;;AAIA;EACE,2DAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EAEA,gBAAA;AAFF;;AAKA;EACE,eAAA;EAEA,mBAAA;EAEA,cAAA;EAEA,gBAAA;AALF;;AAQA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AALF;;AAQA;EACE,sDAAA;AALF;;AAQA;EACE,+BAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,sBAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,iBAAA;EACA,mBAAA;AALF;;AAQA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AALF;;AAQA;EACE,+BAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;;EAEE,kBAAA;EACA,mBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,qBAAA;EACA,eAAA;EAEA,oCAAA;AANF;;AASA;EACE,iCAAA;AANF","sourcesContent":["ion-toolbar.drag-bar {\n  -webkit-app-region: drag;\n}\n\nion-menu ion-content {\n  --padding-top: 44px;\n  --background: rgba(var(--ion-color-light-rgb), 0.5);\n}\n\nion-split-pane {\n  --side-max-width: 50%;\n  --side-width: 250px;\n  --side-min-width: 90px;\n  ion-menu {\n    --width: 100%;\n    transition: border 0.25s;\n    ion-list,\n    ion-item,\n    ion-list-header {\n      --background: rgba(var(--ion-color-light-rgb), 0.5);\n    }\n  }\n}\n\nion-menu.md ion-content {\n  --padding-top: 20px;\n  --padding-bottom: 20px;\n}\n\nion-menu.md ion-list {\n  padding: 0 0;\n}\n\nion-menu.md ion-note {\n  margin-bottom: 30px;\n}\n\nion-menu.md ion-list-header,\nion-menu.md ion-note {\n  padding-left: 10px;\n}\n\nion-menu ion-list#top-list {\n  ion-item.title {\n    --min-height: 95px;\n    ion-label {\n      font-size: 22px;\n      font-weight: 600;\n    }\n  }\n}\n\nion-menu.md ion-list#top-list {\n  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);\n}\n\nion-menu.md ion-list#top-list ion-list-header {\n  font-size: 22px;\n  font-weight: 600;\n\n  min-height: 20px;\n}\n\nion-menu.md ion-list#labels-list ion-list-header {\n  font-size: 16px;\n\n  margin-bottom: 18px;\n\n  color: #757575;\n\n  min-height: 26px;\n}\n\nion-menu.md ion-item {\n  --padding-start: 10px;\n  --padding-end: 10px;\n  border-radius: 4px;\n}\n\nion-menu.md ion-item.selected {\n  --background: rgba(var(--ion-color-primary-rgb), 0.14);\n}\n\nion-menu.md ion-item.selected ion-icon {\n  color: var(--ion-color-primary);\n}\n\nion-menu.md ion-item ion-icon {\n  color: #616e7e;\n}\n\nion-menu.md ion-item ion-label {\n  font-weight: 500;\n}\n\nion-menu.ios ion-content {\n  --padding-bottom: 20px;\n}\n\nion-menu.ios ion-list {\n  padding: 0;\n}\n\nion-menu.ios ion-note {\n  line-height: 24px;\n  margin-bottom: 20px;\n}\n\nion-menu.ios ion-item {\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --min-height: 50px;\n}\n\nion-menu.ios ion-item.selected ion-icon {\n  color: var(--ion-color-primary);\n}\n\nion-menu.ios ion-item ion-icon {\n  font-size: 24px;\n  color: #73849a;\n}\n\nion-menu.ios ion-list ion-list-header {\n  padding-bottom: 8px;\n}\n\nion-menu.ios ion-list-header,\nion-menu.ios ion-note {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\nion-menu.ios ion-note {\n  margin-bottom: 8px;\n}\n\nion-note {\n  display: inline-block;\n  font-size: 16px;\n\n  color: var(--ion-color-medium-shade);\n}\n\nion-item.selected {\n  --color: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
